

export const isChatAssignedToUser = (chatRoomMetadata, user) => chatRoomMetadata.attendentId === user.id;



// WEBPACK FOOTER //
// ./src/utils/Chat.js